import { Component } from '@angular/core';

/**
 * directives
 */
import { FormFieldGroupDirective } from '@sharedModules/forms/directives/form-field-group/form-field-group.directive';

@Component({
  selector: 'app-field-group',
  styleUrl: './field-group.component.scss',
  template: `<ng-content />`,
  hostDirectives: [
    { 
      directive: FormFieldGroupDirective,
      inputs: ['merge', 'rounded', 'size']
    }
  ],
  imports: [],
})
export class FieldGroupComponent {}
